import * as React from "react";
import ImageList from "@mui/material/ImageList";
import ImageListItem from "@mui/material/ImageListItem";
import { useEffect } from "react";
import { collection, getDocs } from "firebase/firestore";
import { db } from "../../firebase";

export default function MyImageList() {
  const [images, setImages] = React.useState([]);
  const bannerRef = collection(db, "banner");

  useEffect(() => {
    getDocs(bannerRef).then((snapshot) => {
      const data = snapshot.docs.map((doc) => ({
        ...doc.data(),
        id: doc.id,
      }));
      setImages(data);
    });
  }, []);

  return (
    <ImageList sx={{ width: 800, height: 450 }} cols={2} rowHeight={164}>
      {images.map((item) => (
        <ImageListItem key={item.imageURL}>
          <img
            src={`${item.imageURL}?w=164&h=164&fit=crop&auto=format`}
            srcSet={`${item.imageURL}?w=164&h=164&fit=crop&auto=format&dpr=2 2x`}
            alt="Juba Mall"
            loading="lazy"
          />
        </ImageListItem>
      ))}
    </ImageList>
  );
}
